const isDev = import.meta.env.DEV;

const write = (method, ...args) => {
  const target = console?.[method];
  if (typeof target === 'function') {
    target(...args);
  }
};

export const logger = {
  dev: (...args) => {
    if (!isDev) return;
    write('log', ...args);
  },

  info: (...args) => {
    write('info', ...args);
  },

  warn: (...args) => {
    write('warn', ...args);
  },

  error: (...args) => {
    write('error', ...args);
  },
};

